import { Link } from 'react-router-dom';
import { trackingItems } from '@/mocks/tracking';
import SectionHeading from '@/components/base/SectionHeading';

const statusStyle: Record<string, string> = {
  已核实: 'bg-secondary-500 text-background-50',
  多方信源: 'bg-primary-500 text-background-50',
  待回应: 'bg-accent-600 text-background-50',
};

export default function TrackingSection() {
  return (
    <section id="tracking" className="bg-foreground-950 text-background-50 scroll-mt-28">
      <div className="px-4 md:px-8 py-12 md:py-16">
        <div className="[&_h2]:text-background-50 [&_p]:text-background-200/80 [&_span]:text-primary-300">
          <SectionHeading
            eyebrow="LIVE TRACKING"
            title="独家追踪时间线"
            desc="事件有实质进展时，我们更新原有时间线，而不是重复发一篇。"
          />
        </div>
        <div className="grid lg:grid-cols-12 gap-8">
          <ol className="lg:col-span-8 relative border-l border-background-50/15 ml-2 space-y-7">
            {trackingItems.map((item, i) => (
              <li key={item.articleId} className="relative pl-7">
                <span
                  className={`absolute -left-[7px] top-1.5 w-3.5 h-3.5 rounded-full border-2 border-foreground-950 ${
                    i === 0 ? 'bg-accent-500' : 'bg-primary-400'
                  }`}
                ></span>
                <div className="flex flex-wrap items-center gap-3 mb-2">
                  <span className="font-heading font-bold text-sm text-primary-300">{item.date}</span>
                  <span className={`px-2 py-0.5 rounded text-xs ${statusStyle[item.status] ?? 'bg-background-50/15 text-background-100'}`}>
                    {item.status}
                  </span>
                </div>
                <Link
                  to={`/article/${item.articleId}`}
                  className="group inline-block cursor-pointer"
                >
                  <h3 className="font-heading font-bold text-base md:text-lg text-background-50 group-hover:text-primary-300 transition-colors">
                    {item.title}
                  </h3>
                </Link>
                <p className="mt-2 text-sm text-background-200/70 leading-relaxed">{item.note}</p>
              </li>
            ))}
          </ol>

          <aside className="lg:col-span-4">
            <div className="rounded-lg border border-background-50/15 bg-background-50/5 p-6">
              <h3 className="font-heading font-bold text-lg text-background-50">核实状态说明</h3>
              <ul className="mt-5 space-y-4 text-sm">
                <li className="flex items-start gap-3">
                  <span className="mt-1 w-2.5 h-2.5 rounded-full bg-secondary-500 shrink-0"></span>
                  <span className="text-background-200/80">
                    <strong className="text-background-50">已核实</strong>：至少两个独立信源指向同一结论，且能被公开材料印证。
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="mt-1 w-2.5 h-2.5 rounded-full bg-primary-500 shrink-0"></span>
                  <span className="text-background-200/80">
                    <strong className="text-background-50">多方信源</strong>：多个信源在关键节点上一致，但仍有细节待补。
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="mt-1 w-2.5 h-2.5 rounded-full bg-accent-600 shrink-0"></span>
                  <span className="text-background-200/80">
                    <strong className="text-background-50">待回应</strong>：方向可推断，相关方尚未公开回应。
                  </span>
                </li>
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}